/**
 * Portal display helpers for rider availability.
 * Assignment eligibility stays Online-only (isAvailable / isAssignable).
 */

export function resolveAvailabilityStatus(partner = {}) {
  if (partner.availabilityStatus) return partner.availabilityStatus
  if (partner.isAvailable === true) return "Online"
  return "Offline"
}

export function getRiderAvailabilityDisplay(partner, t) {
  const status = resolveAvailabilityStatus(partner)
  const isAssignable =
    partner.isAvailable ?? status === "Online"

  switch (status) {
    case "Online":
      return {
        status,
        isAssignable,
        label: t("Available"),
        riderLabel: t("Available Rider"),
        color: "#34c38f",
        textClass: "text-success",
      }
    case "OnDelivery":
      return {
        status,
        isAssignable: false,
        label: t("On Delivery"),
        riderLabel: t("On Delivery"),
        color: "#f1b44c",
        textClass: "text-warning",
      }
    case "TemporarilyUnavailable":
      return {
        status,
        isAssignable: false,
        label: t("Temporarily Unavailable"),
        riderLabel: t("Temporarily Unavailable"),
        color: "#f46a6a",
        textClass: "text-danger",
      }
    default:
      return {
        status: "Offline",
        isAssignable: false,
        label: t("Not Available"),
        riderLabel: t("Not Available"),
        color: "#f46a6a",
        textClass: "text-danger",
      }
  }
}
